import { createAxiosClient } from './api/index.ts'
import { createLocalStorageService } from './storage/index.ts'
import { createConsoleLogger } from './logger/index.ts'
import { createSupabaseDatabase } from './database/index.ts'
import { createDeadmanSwitchService } from './contract/index.ts'
import { createLitEncryptionService } from './encryption/index.ts'
import { createPinataService } from './ipfs/index.ts'
import { createNotificationService } from './notification/index.ts'
import { env } from '@/config/env.ts'

export const apiClient = createAxiosClient()
export const storage = createLocalStorageService()
export const logger = createConsoleLogger()
export const db = createSupabaseDatabase()
export const deadmanSwitch = createDeadmanSwitchService()
export const encryption = createLitEncryptionService()
export const ipfs = createPinataService('', env.pinataGateway)
export const notifications = createNotificationService()

export type { ApiClient, ApiRequestConfig, ApiResponse } from './api/index.ts'
export type { StorageService } from './storage/index.ts'
export type { Logger, LogLevel } from './logger/index.ts'
export type { WalletInfo, WalletService } from './wallet/index.ts'
export type {
  DatabaseClient,
  DatabaseResponse,
  DatabaseError,
  QueryFilter,
  QueryOptions,
  RealtimePayload,
} from './database/index.ts'
export type {
  DeadmanSwitchService,
  Subscription,
  Vault,
  VaultDecryptionInfo,
  PricingInfo,
  TokenInfo,
  CreateVaultParams,
  ContractWriteResult,
  ContractConfig,
} from './contract/index.ts'
export type { SubscriptionTierType } from './contract/index.ts'
export {
  SubscriptionTier,
  contractConfig,
  DEADMAN_SWITCH_ABI,
} from './contract/index.ts'
export type {
  EncryptionService,
  EncryptionResult,
  DecryptionResult,
  EncryptStringParams,
  EncryptFileParams,
  DecryptParams,
  UnifiedAccessControlCondition,
  EncryptionNetwork,
  AuthSession,
  VaultPayload,
  VaultPayloadV1,
  VaultPayloadV2,
} from './encryption/index.ts'
export type {
  IPFSStorageService,
  IPFSUploadResult,
  IPFSDownloadResult,
  IPFSUploadOptions,
} from './ipfs/index.ts'
export type {
  NotificationService,
  NotificationResult,
  NotificationRecord,
  NotificationHistoryFilter,
  EmailPayload,
  SMSPayload,
  WhatsAppPayload,
  TelegramPayload,
  PushPayload,
  PushSubscriptionData,
} from './notification/index.ts'
export { NotificationChannel } from './notification/index.ts'
export { wagmiAdapter } from './wallet/index.ts'
export { getSupabaseClient } from './database/index.ts'
